export var DEFAULT_DISTANCE_FROM_CONTAINER = 20;